export const PAGINATION = "PAGINATION";
export const PAGE = "PAGE";
export const TOTAL = "TOTAL";
export const LIMIT = "LIMIT";
